import React, { useState } from "react";
import Title from "../../../Components/Title/Title";
import Card, { CardBody } from "../../../Components/Card";
import { formatToPersianAddComma } from "../../../utils/CommaSeparator";
import "./NotifySection.scss";
import Swal from "sweetalert2";
import _axios from "../../../httpService";
import { prefixUrl } from "../../../utils/utilsData";

const NotifySection = (props) => {
  const { notifyReport, updateData, setUpdateData, showCloseKey } = props;
  const [openUserReport, setOpenUserReport] = useState(true);
  const besClasses = openUserReport ? "bes show-bes" : "bes";

  function closeKeyHandler(item) {
    let itemName = `بستن حساب `;
    const title = ` بستن حساب `;
    const text = `آیا از بستن حساب ها مطمئن هستید`;
    Swal.fire({
      title,
      text,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر و لغو عملیات",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        let timerInterval;

        Swal.fire({
          title: "در حال انجام فرآیند بستن  " + itemName,
          // allowOutsideClick: false,
          // timer: 5000,
          html: "<b></b>",
          // timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            const b = Swal.getHtmlContainer().querySelector("b");
            timerInterval = setInterval(() => {
              b.textContent = Swal.getTimerLeft();
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            // console.log('I was closed by the timer')
          }
        });

        // setTimeout(() => {
        //   // toast.dismiss()
        //   Swal.fire(itemName + ' با موفقیت بسته شد', '', 'success')
        // }, 1000)

        let object = {
          request: "closeFund",
          data: notifyReport,
        };
        _axios.post(prefixUrl() + "/fundCheck/", object).then((res) => {
          const data = res.data;

          if (data.status) {
            Swal.fire(`${data.message}`, "", "success");
            setUpdateData(!updateData);
          } else {
            Swal.fire(
              `${data.message ? data.message : "حذف نشد."}`,
              "",
              "error"
            );
          }
        });
      }
    });
  }

  try {
    return (
      <div className="bill">
        <div
          className="colapse-row"
          onClick={() => setOpenUserReport(!openUserReport)}
        >
          <Title title={"صورتحساب"} />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="9"
            viewBox="0 0 18 9"
            fill="none"
          >
            <path
              d="M8.9995 8.8001C8.2995 8.8001 7.5995 8.5301 7.0695 8.0001L0.549531 1.48014C0.259531 1.19014 0.259531 0.710137 0.549531 0.420137C0.839531 0.130137 1.31953 0.130137 1.60953 0.420137L8.1295 6.9401C8.6095 7.4201 9.3895 7.4201 9.8695 6.9401L16.3895 0.420137C16.6795 0.130137 17.1595 0.130137 17.4495 0.420137C17.7395 0.710137 17.7395 1.19014 17.4495 1.48014L10.9295 8.0001C10.3995 8.5301 9.6995 8.8001 8.9995 8.8001Z"
              fill="#808487"
            />
          </svg>
        </div>

        <Card className="billCard">
          <CardBody>
            {" "}
            <div className={besClasses}>
              {notifyReport?.map(
                (
                  item: {
                    label1: string,
                    // label2: string;
                    value: number,
                    currency: string,
                    type: string,
                    id: number,
                    showCloseKey: boolean,
                  },
                  index: number
                ) => {
                  return (
                    <>
                      <ul key={index + ""} className="user-report-item">
                        <li className="bill-labels">
                          <span className="first-label">{item.label1}</span>

                          {/*<span className="second-label">{item.label2}</span>*/}
                        </li>
                        <li className="dashboard-bill-value">
                          {formatToPersianAddComma(item.value)}{" "}
                          <span className="bill-currency">{item.currency}</span>
                        </li>
                      </ul>
                    </>
                  );
                }
              )}
              <div
                className={"hereIAm"}
                style={{ position: "absolute", bottom: "0", right: "28%" }}
              >
                {showCloseKey && (
                  <button className="btn btn-outline-danger dashboard-bill-close">
                  <span className="" onClick={() => closeKeyHandler()}>
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <g clipPath={"url(#clip0_113_59)"}>
                          <path
                            d="M6.11295 10.3867C5.98628 10.3867 5.85962 10.34 5.75962 10.24C5.56629 10.0467 5.56629 9.72665 5.75962 9.53332L9.53297 5.75999C9.7263 5.56666 10.0463 5.56666 10.2396 5.75999C10.433 5.95332 10.433 6.27332 10.2396 6.46666L6.46628 10.24C6.37295 10.34 6.23962 10.3867 6.11295 10.3867Z"
                            fill="#FB6B7A"
                          />
                          <path
                            d="M9.8863 10.3867C9.75964 10.3867 9.63297 10.34 9.53297 10.24L5.75962 6.46666C5.56629 6.27332 5.56629 5.95332 5.75962 5.75999C5.95295 5.56666 6.27295 5.56666 6.46628 5.75999L10.2396 9.53332C10.433 9.72665 10.433 10.0467 10.2396 10.24C10.1396 10.34 10.013 10.3867 9.8863 10.3867Z"
                            fill="#FB6B7A"
                          />
                          <path
                            d="M10 15.1666H6.00004C2.38004 15.1666 0.833374 13.6199 0.833374 9.99992V5.99992C0.833374 2.37992 2.38004 0.833252 6.00004 0.833252H10C13.62 0.833252 15.1667 2.37992 15.1667 5.99992V9.99992C15.1667 13.6199 13.62 15.1666 10 15.1666ZM6.00004 1.83325C2.92671 1.83325 1.83337 2.92658 1.83337 5.99992V9.99992C1.83337 13.0733 2.92671 14.1666 6.00004 14.1666H10C13.0734 14.1666 14.1667 13.0733 14.1667 9.99992V5.99992C14.1667 2.92658 13.0734 1.83325 10 1.83325H6.00004Z"
                            fill="#FB6B7A"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_113_59">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      بستن حساب ها
                    </>
                  </span>
                  </button>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }catch (error){
    return <>{error.toString()}</>
  }
};

export default NotifySection;
